<template>
  <div>
    <div class="fixed-top">
      <nav class="navbar navbar-expand-lg" :class="$store.state.unidade.tem_cor ? 'navbar-' + getTextColor($store.state.unidade.st_cor_barra, true) : 'bg-primary navbar-dark'"
        :style="$store.state.unidade.tem_cor ? 'background-color: ' + $store.state.unidade.st_cor_barra : ''">
        <router-link to="/" class="navbar-brand">
          <span style="font-family: 'Acme', sans-serif;">
            klingo
          </span>
        </router-link>
        <az-breadcrumb-first></az-breadcrumb-first>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>


        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <div :class="$store.state.unidade.tem_cor ? 'text-' + getTextColor($store.state.unidade.st_cor_barra) : 'text-white'">
            <i class="far fa-building ml-1 mr-2" aria-hidden="true"></i>
            <span class="mb-0">
              {{ $store.state.unidade.search }}
            </span>
            <span v-if="$store.state.user.id_unidade_operacao">
              / {{ unidade_nome() }}
            </span>
            <!--
            <a href="#" @click.prevent="trocar_unidade()" class="card-link">
              <i class="far fa-building text-white ml-1 mr-2" aria-hidden="true"></i>
              <span class="text-white mb-0">{{ $store.state.unidade.search }}</span>
            </a>
            -->
          </div>

          <!-- Menu do Usu[ario -->
          <ul class="navbar-nav ml-auto">
            <li v-if="$store.state.user && $store.state.user.atalhos && $store.state.user.atalhos.length" class="nav-item dropdown d-flex flex-row align-items-center">
                <a
                    id="navbarDropdown"
                    class="nav-link active d-flex flex-row align-items-center mr-5"
                    href="#"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <i class="fa-solid fa-square-up-right"></i>
                </a>

                <div class="dropdown-menu dropdown-menu-scroll-lg dropdown-menu-right w3-animate-opacity" aria-labelledby="navbarDropdown">
                    <a :href="atalho.st_url" class="dropdown-item ddip-card" target="_blank" v-for="(atalho, iax) in $store.state.user.atalhos" :key="iax">
                        {{ atalho.st_titulo }}
                    </a>
                </div>
            </li>

            <li>
              <!-- Pesquisar -->
              <form class="form-inline pt-1 mb-0" @submit.prevent>
                <div class="input-group mr-sm-2" id="autocomplete-paciente">
                  <AutocompletePaciente :color="getTextColor($store.state.unidade.st_cor_barra)" @recentes="abrir_pacientes_recentes" />
                </div>
              </form>
            </li>
            <li class="nav-item dropdown">
              <a
                id="navbarDropdown"
                class="nav-link active d-flex flex-row align-items-center"
                href="#"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <div :data-initials="$store.state.user.initials"></div>
                <div class="caret" v-if="1 == 0"></div>
              </a>

              <div
                id="creek-dropdown"
                class="dropdown-menu dropdown-menu-scroll-lg dropdown-menu-right w3-animate-opacity"
                aria-labelledby="navbarDropdown"
              >
                <a href="#" class="dropdown-item ddip-card disabled" @click.prevent>{{ $store.state.user.search }}</a>
                <template v-if="$store.state.user.id_usuario != 1">
                  <div class="dropdown-divider"></div>
                  <a href="#" class="dropdown-item ddip-card" @click.prevent="alterar_minha_senha()">Alterar minha senha</a>
                  <a href="#" class="dropdown-item ddip-card" @click.prevent="config_papel()">Selecionar Papel</a>
                </template>
                <a href="#" class="dropdown-item ddip-card" @click.prevent="$router.push({ name: 'tarefas' })">Tarefas</a>
                <div class="dropdown-divider"></div>
                <template v-for="(menu, imx) in menu_contexto">
                  <router-link class="dropdown-item ddip-card" v-if="menu.route == $route.path && ( !menu.teste || $store.state.user.id_usuario == 1 ) " :to="menu.to" :key="imx">{{ menu.title }}</router-link>
                </template>

                <!-- Mëdico -->
                <template v-if="this.$store.state.user.medico">
                  <router-link class="dropdown-item ddip-card" :to="{ name: 'modelos' }">Modelos de Prontuário</router-link>
                  <router-link class="dropdown-item ddip-card" :to="{ name: 'modelos-doc' }">Modelos de Documento</router-link>
                  <div class="dropdown-divider"></div>
                  <router-link class="dropdown-item ddip-card" :to="{ name: 'kit', params: { tipo: 'medicamento' } }">Kits de Medicamento</router-link>
                  <router-link class="dropdown-item ddip-card" :to="{ name: 'kit', params: { tipo: 'procedimento' } }">Kits de Procedimento</router-link>
                  <div class="dropdown-divider"></div>
                  <router-link class="dropdown-item ddip-card" :to="{ name: 'certificado' }">Certificado Digital</router-link>
                  <router-link class="dropdown-item ddip-card" :to="{ name: 'delegacao' }">Delegação de Acesso</router-link>
                  <div class="dropdown-divider"></div>
                </template>
                
                <!-- Solicitação de Materiais -->
                <template v-if="$store.state.user.avisos">
                  <a href="#" class="dropdown-item ddip-card" @click.prevent="ir_para_avisos()">Cadastrar Avisos</a>
                  <div class="dropdown-divider"></div>
                </template>

                <!-- Solicitação de Materiais -->
                <template v-if="tem_suprimentos && solicita_mat">
                  <a href="#" class="dropdown-item ddip-card" @click.prevent="solic_estoque()">Solicitar Material para Consumo</a>
                  <a href="#" class="dropdown-item ddip-card" @click.prevent="solic_estoque('D')">Solicitar Devolução de Material para Consumo</a>
                  <a href="#" class="dropdown-item ddip-card" @click.prevent="solic_estoque('T')">Solicitar Transferência de Material</a>
                  <a href="#" class="dropdown-item ddip-card" @click.prevent="solic_estoque('A')">Solicitar Compra de Material</a>
                  <div class="dropdown-divider"></div>
                </template>

                <a class="dropdown-item ddip-card d-flex justify-content-between" href="#" @click.prevent="logout()">
                    <div>
                        Sair
                    </div>
                    <div>
                        <span class="small text-muted ml-3" :title="$store.state.user.id_usuario == 1 ? buildDate : 'v'">{{ commit_num }}</span>
                        <span class="badge ml-3" :class="tempo_inatividade < 60 ? 'badge-danger' : 'badge-light'" v-if="tempo_inatividade > 0" title="Tempo de Inatividade">
                            {{ tempo_inatividade }}
                        </span>
                    </div>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </nav>

      <nav class="navbar navbar-expand-lg bg-white navbar-light d-flex justify-content-between">
        <az-breadcrumb />
        <div class="d-flex">
          <div class="text-danger" v-if="!$store.state.online">
            <i class="fas fa-unlink"></i>
          </div>
          <div class="ml-2" v-if="$store.state.loading">
            <div class="spinner-grow spinner-grow-sm" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div class="text-muted ml-2" v-if="mostrar_local" id="identificacao-local">
            <span class="d-md-block d-none">
              <a href="#" class="card-link" @click.prevent="editar_local()">
                {{ exibir ? exibir : "" }}
                <i class="fa fa-building-o ml-2" aria-hidden="true"></i>
              </a>
            </span>
            <span class="d-block d-md-none">
              <a href="#" class="card-link" @click.prevent="editar_local()">
                <i class="fa fa-building-o ml-2" aria-hidden="true"></i>
              </a>
            </span>
          </div>

          <div class="text-muted ml-2" v-else-if="mostrar_ramal" id="identificacao-ramal">
            <a href="#" class="card-link" @click.prevent="editar_ramal()">
              {{ exibir_ramal ? exibir_ramal : "" }}
              <i class="fas fa-phone-square-alt ml-2"></i>
            </a>
          </div>

          <az-chat-button id="botao-chat" @abrir="abrir_chat" />

        </div>
      </nav>

    </div>

    

    <az-chat ref="chat" />
    <az-chat-panel v-if="false" />

    <modelo-impressao />

    <!-- Modal Pacientes Recentes, Busca Macro -->
    <div class="modal fade" id="pacientesRecentesModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
            <div class="modal-content" v-if="pacientes_recentes">
                <div class="modal-header">
                    <h5 class="modal-title">Pacientes Recentes</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="list-group">
                        <button type="button" class="list-group-item list-group-item-action" v-for="(recente, irx) in pacientes_recentes" :key="irx" @click="abrir_recente(recente)">
                            {{ recente.search }}
                        </button>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="localGlobalModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
        <div class="modal-content" v-if="edicao_local">
          <div class="modal-header">
            <h5 class="modal-title">Localização</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <az-input
              label="Unidade"
              type="select"
              optionsData="id_unidade_operacao"
              :optionsList="$util.unidades_com_tags(false, true)"
              v-if="$store.state.unidade.unidade_operacaos.length > 1"
              v-model="edicao_local.id_unidade_operacao" />

            <az-input
              v-if="edicao_local.id_unidade_operacao && recepcoes.length > 1"
              label="Recepção Associada"
              type="select"
              optionsData="id_recepcao"
              :optionsList="recepcoes"
              v-model="edicao_local.id_recepcao" />

            <template v-if="$route.path == '/consultorio' || edicao_local.local || ( edicao_local.id_unidade_operacao && edicao_local.id_recepcao )">
              <div class="form-row">
                <div class="col col-12 col-md-6">
                  <az-input 
                    label="Informe aonde você está localizado"
                    placeholder="Ex.: Guichê 4, Consultório 3, Sala de Exames 2..."
                    v-model="edicao_local.local" />
                </div>
                <div class="col col-12 col-md-6">
                  <az-input
                    type="number"
                    label="Tempo máximo de espera"
                    placeholder="Não definido..."
                    v-model="edicao_local.te_max">
                    <template v-slot:buttonposb>
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">minuto(s)</span>
                      </div>
                    </template>
                  </az-input>
                </div>
              </div>

              <div class="form-row mt-2">
                <div class="col col-12 col-md-6">
                  <az-input
                    type="checkbox-group"
                    label="Não enviar mensagem para o painel de chamada"
                    v-model="edicao_local.nao_enviar_painel" />
                </div>
                <div class="col col-12 col-md-6">
                  <az-input
                    type="checkbox-group"
                    label="Emitir som na recepção na chamada de paciente"
                    v-model="edicao_local.recepcao_som_ao_chamar" />
                </div>
              </div>
              <div class="form-row">
                <div class="col col-12 col-md-6">
                  <az-input
                    type="checkbox-group"
                    label="Não exibir mensagem de aviso de paciente chamado"
                    v-model="edicao_local.nao_exibir_aviso_ao_chamar" />
                </div>
                <div class="col col-12 col-md-6">
                  <az-input
                    type="checkbox-group"
                    label="Não fazer refresh automático na recepção"
                    v-model="edicao_local.block_recep_refresh" />
                </div>
              </div>
            </template>

            <template v-if="( $route.path == '/recepcao' || $route.path == '/internacao/internados' || $route.path == '/crm' ) && edicao_local.id_recepcao && link_painel()">

              <hr>

              <div class="row mt-3">
                <div class="col col-4 d-flex flex-column justify-content-between">
                    <div class="text-center">
                        <i class="fas fa-tv fa-4x text-dark my-2"></i>
                    </div>
                    <div>
                        <az-input 
                          sizing="sm"
                          type="checkbox-group"
                          label="Data de Nascimento em campo livre"
                          v-model="edicao_local.dnc" />
                    </div>
                </div>
                <div class="col-4 d-flex flex-column">
                  <a :href="link_painel()" class="btn btn-outline-primary mb-1" target="_blank">
                    <i class="fa fa-play mr-2" aria-hidden="true"></i>
                    Abrir Painel de Chamada
                  </a>
                  <a :href="$store.state.unidade.check_in_link + '?totem=1&uo=' + edicao_local.id_unidade_operacao + '&r=' + edicao_local.id_recepcao + complemento_url_totem"
                    class="btn btn-outline-primary mb-1 mt-2" target="_blank"
                    v-if="$store.state.unidade.check_in_link">
                    <i class="fa fa-check-square mr-2" aria-hidden="true"></i>
                    Totem para Check-In
                  </a>

                  <a :href="$store.state.unidade.check_in_link + '?totem=1&uo=' + edicao_local.id_unidade_operacao + '&r=' + edicao_local.id_recepcao + '&bt=1' + complemento_url_totem"
                    class="btn btn-outline-primary mb-1" target="_blank"
                    v-if="$store.state.unidade.check_in_link">
                    <i class="fa fa-check-square mr-2" aria-hidden="true"></i>
                    Totem para Check-In (+ Botões)
                  </a>

                  <a :href="$store.state.unidade.check_in_link + '?totem=1&uo=' + edicao_local.id_unidade_operacao + '&r=' + edicao_local.id_recepcao + '&dn=1' + complemento_url_totem"
                    class="btn btn-outline-primary mb-1" target="_blank"
                    v-if="$store.state.unidade.check_in_link">
                    <i class="fa fa-check-square mr-2" aria-hidden="true"></i>
                    Totem para Check-In (Dt Nasc)
                  </a>

                  <a :href="$store.state.unidade.check_in_link + '?totem=1&uo=' + edicao_local.id_unidade_operacao + '&r=' + edicao_local.id_recepcao + '&dn=1&cpf=1' + complemento_url_totem"
                    class="btn btn-outline-primary mb-1" target="_blank"
                    v-if="$store.state.unidade.check_in_link">
                    <i class="fa fa-check-square mr-2" aria-hidden="true"></i>
                    Totem para Check-In (CPF)
                  </a>

                  <template v-if="false">
                    <button type="button" class="btn btn-outline-primary mb-1" @click="qrcode_link()"
                      v-if="$store.state.unidade.check_in_link">
                      <i class="fa fa-qrcode mr-2"></i>
                      QR Code para Check-In
                    </button>
                    <a :href="$store.state.unidade.check_in_link" class="btn btn-outline-primary mb-1" target="_blank"
                      v-if="$store.state.unidade.check_in_link">
                      <i class="fa fa-check-circle mr-2" aria-hidden="true"></i>
                      Página de Check-In
                    </a>
                  </template>
                  
                </div>
                <div class="col-4 d-flex flex-column">
                  <button type="button" class="btn btn-outline-primary mb-1" @click="copiar_clipboard(link_painel())">
                    <i class="fas fa-copy mr-2"></i>
                    Copiar Link do Painel
                  </button>
                  
                  <a :href="$store.state.unidade.check_in_link + '?totem=1&uo=' + edicao_local.id_unidade_operacao + '&r=' + edicao_local.id_recepcao + '&semagenda=1' + '&sufixosi=' + sufixo_servidor_impressao + complemento_url_totem"
                    class="btn btn-outline-primary mb-1 mt-2" target="_blank"
                    v-if="$store.state.unidade.check_in_link && recepcao
                      && ( ( recepcao.adicoes && recepcao.adicoes.length )
                      || ( recepcao.subs && recepcao.subs.find(sub => sub.adicoes && sub.adicoes.length ) ) )">
                    <i class="fa fa-check-square mr-2" aria-hidden="true"></i>
                    Totem para Check-In sem Agenda
                  </a>
                  <a :href="$store.state.unidade.check_in_link + '?totem=1&uo=' + edicao_local.id_unidade_operacao + '&r=' + edicao_local.id_recepcao + '&semagenda=1&bt=1' + '&sufixosi=' + sufixo_servidor_impressao + complemento_url_totem"
                    class="btn btn-outline-primary mb-1" target="_blank"
                    v-if="$store.state.unidade.check_in_link && recepcao
                      && ( ( recepcao.adicoes && recepcao.adicoes.length )
                      || ( recepcao.subs && recepcao.subs.find(sub => sub.adicoes && sub.adicoes.length ) ) )">
                    <i class="fa fa-check-square mr-2" aria-hidden="true"></i>
                    Totem para Check-In sem Agenda (Botão)
                  </a>

                  <a :href="$store.state.unidade.check_in_link + '?totem=1&uo=' + edicao_local.id_unidade_operacao + '&r=' + edicao_local.id_recepcao + '&dn=1&bt=1' + '&sufixosi=' + sufixo_servidor_impressao + complemento_url_totem"
                    class="btn btn-outline-primary mb-1" target="_blank"
                    v-if="$store.state.unidade.check_in_link">
                    <i class="fa fa-check-square mr-2" aria-hidden="true"></i>
                    Totem para Check-In (Dt Nasc / Botões)
                  </a>

                  <a :href="$store.state.unidade.check_in_link + '?totem=1&uo=' + edicao_local.id_unidade_operacao + '&r=' + edicao_local.id_recepcao + '&dn=1&bt=1' + '&cpf=1&sufixosi=' + sufixo_servidor_impressao + complemento_url_totem"
                        class="btn btn-outline-primary mb-1" target="_blank"
                        v-if="$store.state.unidade.check_in_link">
                        <i class="fa fa-check-square mr-2" aria-hidden="true"></i>
                        Totem para Check-In (CPF / Botões)
                  </a>

                </div>
              </div>

              <div class="row mt-1">
                <div class="col">
                  <label class="form-control text-center">{{ link_painel() }}</label>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <az-input
                    type="checkbox-group"
                    label="Espaço pra Vídeo no Painel de Chamada"
                    v-model="com_video" />
                </div>
              </div>

              <div class="row" v-if="com_video">
                <div class="col">
                  <az-input
                    label="Código do Vídeo do Youtube (EMBED)"
                    placeholder="Opcional... Ex.: obkrMiyDrbs..."
                    v-model="codigo_video" />
                </div>
              </div>

            </template>

            <template v-if="$route.path == '/recepcao' || $route.path == '/laboratorio/coleta'">
              <div class="form-row">
                <div class="col col-12 col-md-6">
                  <div class="small text-muted mt-2">
                    Servidor de impressão para etiquetas de laboratório.
                  </div>
                  <input type="text" class="form form-control" v-model="lab_servidor_impressao" />
                </div>

                <div class="col col-12 col-md-6">
                  <div class="small text-muted mt-2">
                    Servidor de impressão secundário (espelho de atendimento, modelo cupom).
                  </div>
                  <input type="text" class="form form-control" v-model="sis_servidor_impressao" />
                </div>
              </div>

              <div class="form-row">
                <div class="col col-12 col-md-6">
                  <div class="small text-muted mt-2">
                    Sufixo para servidor de impressão de totem.
                  </div>
                  <input type="text" class="form form-control" v-model="sufixo_servidor_impressao" placeholder="Padrão..." />
                </div>
              </div>
            </template>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <button type="button" class="btn btn-success" @click="atualizar_local()">Atualizar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="selecUnidadeModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Unidades</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="list-group">
              <button type="button" class="list-group-item list-group-item-action"
                :class="unidade.id_unidade == $store.state.unidade.id_unidade ? 'active' : '' "
                v-for="(unidade, idx) in $store.state.unidades" :key="idx"
                @click="selecionar_unidade (unidade)">
                {{ unidade.search }}
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Senha -->
    <div class="modal fade" id="minhaSenhaModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content" v-if="edicao_senha">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Alterar Minha Senha</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                  <div class="row mb-1">
                    <div class="col">
                      <az-input
                        type="password"
                        label="Senha Atual"
                        v-model="edicao_senha.senha_atual" />
                    </div>
                  </div>
                  <div class="row mb-1">
                    <div class="col">
                      <az-input
                        type="password"
                        label="Nova Senha"
                        v-model="edicao_senha.nova_senha" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <az-input
                        label="Confirmar Senha"
                        type="password"
                        v-model="edicao_senha.confirmar_senha" />
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    <az-submit @click="atualizarMinhaSenha()">Alterar Senha</az-submit>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="papelModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Selecionar Papel</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <small class="text-muted">Papel</small>
            <select class="form-control" type="select" v-model="pageSize">
              <option value="A4">A4</option>
              <option value="A4-T">A4 (Timbrado)</option>
              <option value="A4-NT">A4 (Não Timbrado)</option>
              <option value="A5">A5</option>
              <option value="A5-T">A5 (Timbrado)</option>
              <option value="A5-NT">A5 (Não Timbrado)</option>
            </select>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <button type="button" class="btn btn-success" @click="atualizar_papel()">Atualizar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="carregandoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <az-loading msg="Aguarde..." />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="modalRamal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Ramal</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <az-input
              placeholder="Ramal..."
              v-model="edicao_ramal" />

            <p class="alert alert-warning">Após a atualização do ramal, necessário re-logar no sistema para habilitar a integração com a telefonia.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <button type="button" class="btn btn-success" @click="definir_ramal()">Atualizar</button>
          </div>
        </div>
      </div>
    </div>

    <estoque-solicitacao ref="solic_geral" /> <!-- v-if="$route.path != '/suprimentos/atendimento'" /> -->

    <exibir-avisos ref="avisos" />

    <div v-show="false">
      <v-idle 
        v-if="tempo_inatividade >= 60"
        @idle="onidle" 
        :duration="tempo_inatividade" 
        @remind="onremind"
        :reminders="[5, 15, 30, 45]" />
    </div>

  </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AutocompletePaciente from "./components/shared/AutocompletePaciente";
import AzBreadcrumbFirst from './components/util/AzBreadcrumbFirst.vue';
import AzInput from './components/shared/forms/AzInput.vue';
import EventBus from './service/EventBus';
import AzChat from './components/shared/chat/AzChat.vue';
import AzChatButton from './components/shared/chat/AzChatButton.vue';
import AzChatPanel from './components/shared/chat/AzChatPanel.vue';
import AzSubmit from './components/util/AzSubmit.vue';
import ModeloImpressao from './components/relatorios/impressao/ModeloImpressao.vue';
import AzLoading from './components/util/AzLoading.vue';
import EstoqueSolicitacao from './components/modulos/suprimentos/EstoqueSolicitacao.vue';
import ExibirAvisos from './components/ExibirAvisos.vue';

export default {
  data() {
    return {
      edicao_local: {
        id_unidade_operacao: "",
        id_recepcao: "",
        local: "",
        recepcao_som_ao_chamar: false,
        nao_exibir_aviso_ao_chamar: false,       
        block_recep_refresh: false, 
        dnc: false, 
      },
      id_unidade_operacao: "",
      id_recepcao: "",
      local: "",
      exibir: "",
      edicao_senha: null,
      menu_contexto: [
        { route: "/consultorio", title: "Configurações", to: { name: 'consultorio-config' } },
        { route: "/faturamento/guias", title: "Configurações", to: { name: 'faturamento-config' } },
        { route: "/internacao/internados", title: "Protocolo de Envio de Guias", to: { name: 'protocolo-envio-int' } },
        { route: "/recepcao", title: "Protocolo de Envio de Guias", to: { name: 'protocolo-envio' } },
        { route: "/recepcao", title: "Fechamento Particular", to: { name: 'fechamento-particular' } },
        { route: "/recepcao", title: "Mapa de Sala", to: { name: 'rmapasala' } },
        { route: "/recepcao", title: "Orçamento", to: { name: 'rorcamento' } },
        { route: "/recepcao", title: "Entrega de Resultado", to: { name: 'entrega-resultado' } },
        { route: "/recepcao", title: "Profissionais Solicitantes", to: { name: 'r-medico-solicitante' } },
        { route: "/recepcao", title: "Informações", to: { name: 'c-recep-info' } },
        { route: "/recepcao" + ( ( this.$store.state.user.medico || !this.$store.state.user.repasse_recepcao ) ? 'Z' : '' ), title: "Relatório de Produção", to: { name: 'c-recep-repasse' } },
        { route: "/repasse/repasses", title: "Sociedades Médicas", to: { name: 'c-sociedades' } },
        { route: "/recepcao", title: "Cerimonial Check-In", to: { name: 'cerimonial-check-in' } },
        { route: "/recepcao" + ( this.$store.state.user.tem_adiantamentos ? '' : 'Z' ), title: "Pagamentos", to: { name: 'pagamentos' } },
        { route: "/recepcao" + ( this.$store.state.user.medico ? 'Z' : '' ), title: "Pagamentos Pendentes", to: { name: 'r-pag-pendentes' } },
        { route: "/consultorio" + ( this.$store.state.user.medico ? '' : 'Z'), title: "Medicamentos", to: { name: 'medicamentos' } },
        { route: "/consultorio", title: "Procedimentos", to: { name: 'procedimentos' } },
        { route: "/laudos/lista", title: "Configurações", to: { name: 'laudos-config' } },
        //{ route: "/consultorio", title: "Orçamento", to: { name: 'corcamento' } },
        // { route: "/reembolso/reembolsos", title: "Logins Enviados", to: { name: 'reembolso-logins' } },
      ],
      pageSize: "A4",
      edicao_ramal: "",
      ramal: "",
      com_video: false,
      codigo_video: "",
      lab_servidor_impressao: "",
      sis_servidor_impressao: "", 
      te_max: "", 
      tempo_inatividade: null, 
      pacientes_recentes: null, 
      sufixo_servidor_impressao: "",
    }
  },
  watch: {
    'edicao_local.id_unidade_operacao': function () {
      if ( !this.edicao_local || !this.edicao_local.id_unidade_operacao )
        return;

      let unid = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.edicao_local.id_unidade_operacao);

      if ( unid ) {

        if ( !unid.recepcaos.length && this.edicao_local.id_recepcao )
          this.edicao_local.id_recepcao = "";
        else if ( unid.recepcaos.length == 1 )
          this.edicao_local.id_recepcao = unid.recepcaos[0].id_recepcao;

      } else {

        if ( this.edicao_local.id_recepcao )
          this.edicao_local.id_recepcao = "";

      }

    }
  },
  computed: {
    commit_num() {
        return process.env.VUE_APP_COMMIT;
    },

    buildDate() {
        return process.env.VUE_APP_BUILD_DATE;
    },

    complemento_url_totem: function() {
      if ( this.edicao_local && this.edicao_local.dnc ) {
        return '&dnc=1';
      } 
      return '';
    },
    tem_suprimentos: function () {
      return this.$store.state.unidade.suprimentos;
    },

    solicita_mat: function () {
      return this.$store.state.unidade.solicita_mat;
    },

    exibir_ramal: function () {
      return this.ramal;
    },

    recepcoes: function () {
      if ( !this.edicao_local || !this.edicao_local.id_unidade_operacao )
        return [];

      let unid = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.edicao_local.id_unidade_operacao);

      if ( unid ) {
        return unid.recepcaos;
      } else {
        return [];
      }
    },

    recepcao: function () {
      return this.recepcoes.find(item => this.edicao_local && item.id_recepcao == this.edicao_local.id_recepcao);
    },

    mostrar_local: function() {
      return this.$route.path.substr(0,9) == '/recepcao'
        || this.$route.path.substr(0,12) == '/consultorio'
        || this.$route.path.substr(0,13) == '/laudos/lista'
        || this.$route.path.substr(0,18) == '/assistencia/atend'
        || this.$route.path.substr(0,19) == '/laboratorio/coleta'
        || this.$route.path.substr(0,7) == '/vacina'
        || this.$route.path.substr(0,11) == '/cerimonial'
        || this.$route.path.substr(0,4) == '/crm'
        || this.$route.path.substr(0,22) == '/internacao/internados'
        || this.$route.path.substr(0,29) == '/centro-cirurgico/atendimento';
    },

    mostrar_ramal: function() {
      return this.$route.path.substr(0,12) == '/call-center';
    },
  },
  components: {
    AutocompletePaciente,
    AzBreadcrumbFirst,
    AzInput,
    AzChat,
    AzChatPanel,
    AzChatButton,
    AzSubmit,
    ModeloImpressao,
    AzLoading,
    EstoqueSolicitacao,
    ExibirAvisos,
  },
  methods: {
    abrir_recente (recente) { 
        $('.modal').modal('hide');

        if ( recente && recente.id_cadastro_temporario ) { 
          this.$root.perfil_temp(recente);
        } else { 
          this.$root.perfil(recente);
        }
    },

    abrir_pacientes_recentes (lista) { 
        this.pacientes_recentes = _.reverse(lista);
        $('#pacientesRecentesModal').modal('show');
    },

    onremind (time) { 
      this.$toast.add({
        severity: "warn",
        summary: "Ocioso",
        detail: "Sistema ocioso. O sistema será desconectado em " + time + " segundos.",
        life: 5000
      });
    },

    onidle() { 
        if ( this.$store.state.user && this.$store.state.user.id_usuario == 1 ) {
          return;
        }

        $('.modal').modal('hide');

        this.$toasted.show(
            'Desconexão realizada por ociosidade', 
            { 
                theme: "toasted-primary", 
                position: "bottom-center", 
                className: "toastnafrente",
                containerClass: "toastnafrente",
                action : [
                    {
                        text : 'Fechar',
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    },
                ]
            }
        );

        this.$store.commit("setUser", null);
    },

    //

    getRGB(c) {
      return parseInt(c, 16) || c
    },

    getsRGB(c) {
      return this.getRGB(c) / 255 <= 0.03928
        ? this.getRGB(c) / 255 / 12.92
        : Math.pow((this.getRGB(c) / 255 + 0.055) / 1.055, 2.4)
    },

    getLuminance(hexColor) {
      return (
        0.2126 * this.getsRGB(hexColor.substr(1, 2)) +
        0.7152 * this.getsRGB(hexColor.substr(3, 2)) +
        0.0722 * this.getsRGB(hexColor.substr(-2))
      )
    },

    getContrast(f, b) {
      const L1 = this.getLuminance(f);
      const L2 = this.getLuminance(b);
      return (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05)
    },

    getTextColor(hexcolor, invert = false) {
        if ( !hexcolor ) { 
          return invert ? 'dark' : 'light';
        }

        var r = parseInt(hexcolor.substring(1,3),16);
        var g = parseInt(hexcolor.substring(3,5),16);
        var b = parseInt(hexcolor.substring(5,7),16);
        var yiq = ((r*299)+(g*587)+(b*114))/1000;
        let color = (yiq >= 128) ? 'dark' : 'light';

        if ( invert ) { 
          color = ( color == 'dark' ? 'light' : 'dark' );
        }

        return color;
    },

    //

    abrir_chat(tipo) {
      this.$refs.chat.abrir(tipo);
    },

    ir_para_avisos() {
      this.$router.push('/avisos');
    },

    solic_estoque(tipo = 'S', parms = null) {
      if ( this.$route.path == '/suprimentos/atendimento' ) {
        this.$toast.add({
          severity: "warn",
          summary: "Solicitação",
          detail: "Tela de atendimento. A solicitação deve ser acessada pelo botão '+'",
          life: 5000
        });

        return;
      }

      $('.modal').modal('hide');

      this.$refs.solic_geral.solicitar(tipo, parms);
    },

    definir_ramal() {
      this.$util.setCookie('ramal', this.edicao_ramal, 365);
      this.ramal = this.edicao_ramal;

      $('#modalRamal').modal('hide');
    },

    editar_ramal() {
      this.edicao_ramal = this.exibir_ramal;

      this.$nextTick(() => {
        $('#modalRamal').modal('show');
      });
    },

    config_papel() {
      this.pageSize = this.$util.getCookie("page-size");
      $('#papelModal').modal('show');
    },

    atualizar_papel() {
      this.$util.setCookie("page-size", this.pageSize, 365);
      $('#papelModal').modal('hide');
    },

    atualizarMinhaSenha() {
      this.$util.atualizar(this, {
        service: 'usuarios',
        func: 'alterar_minha_senha',
        dados: {
          ...this.edicao_senha,
        },
        modal: 'minhaSenhaModal',
        toast: true,
      });
    },

    alterar_minha_senha() {
      this.edicao_senha = {
        senha_atual: "",
        nova_senha: "",
        confirmar_senha: ""
      };

      $('#minhaSenhaModal').modal('show');
    },

    qrcode_link() {
      $('#localGlobalModal').modal('hide');
      this.$router.push({ name: 'qrcode', params: { id_unidade_operacao: this.edicao_local.id_unidade_operacao } });
    },
    link_painel() {
      if ( !this.edicao_local || !this.edicao_local.id_recepcao )
        return "";

      let unidade_operacao = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.id_unidade_operacao);

      if ( unidade_operacao ) {
        let recepcao = unidade_operacao.recepcaos.find(item => item.id_recepcao == this.id_recepcao);

        if ( recepcao )
          return recepcao.link_painel + ( this.com_video ? 'S' : 'N' ) + "/" + encodeURIComponent(this.codigo_video);

      }

    },

    editar_local() {
      this.edicao_local = {
          id_unidade_operacao: "",
          id_recepcao: "",
          local: "", 
          te_max: "", 
          dnc: false, 
        };

      if ( this.id_unidade_operacao ) {
        this.edicao_local.id_unidade_operacao = this.id_unidade_operacao;
        if ( this.id_recepcao ) {
          this.edicao_local.id_recepcao = this.id_recepcao;
        }
      }

      this.edicao_local.local = this.local;
      this.edicao_local.te_max = this.$util.getCookie('te-max');
      this.edicao_local.nao_enviar_painel = this.$util.getCookie('nao-enviar-painel');
      this.edicao_local.recepcao_som_ao_chamar = this.$util.getCookie('recepcao-som-ao-chamar');
      this.edicao_local.nao_exibir_aviso_ao_chamar = this.$util.getCookie('rec-sac');
      this.edicao_local.block_recep_refresh = ( this.$util.getCookie('rec-no-refresh') == 'S' ? true : false );
      this.edicao_local.dnc = ( this.$util.getCookie('dnc') == 'S' ? true : false );

      this.com_video = ( this.$util.getCookie('pnl-video') ==  'S' ? true : false );
      this.codigo_video = this.$util.getCookie('pnl-codigo-video');

      $('#localGlobalModal').modal('show');
    },
    refresh_exibir() {
      let exibir = "";
      let unidade_operacao = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.id_unidade_operacao);

      if ( unidade_operacao ) {

        if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) {
          exibir = unidade_operacao.search;
        }

        let recepcao = unidade_operacao.recepcaos.find(item => item.id_recepcao == this.id_recepcao);

        if ( recepcao && unidade_operacao.recepcaos.length > 1 ) {
          exibir = exibir + ( exibir ? ' / ' : '' ) + recepcao.search;
        }

      }

      if ( this.local ) {
        exibir = exibir + ( exibir ? ' / ' : '' ) + this.local;
      }

      this.exibir = exibir;
    },
    atualizar_local() {
      this.id_unidade_operacao = "";
      this.id_recepcao = "";
      this.local = "";

      if ( this.edicao_local.id_unidade_operacao ) {

        let unidade_operacao = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.edicao_local.id_unidade_operacao);

        if ( unidade_operacao ) {

          this.id_unidade_operacao = unidade_operacao.id_unidade_operacao;

          if ( this.edicao_local.id_recepcao ) {

            let recepcao = unidade_operacao.recepcaos.find(item => item.id_recepcao == this.edicao_local.id_recepcao);

            if ( recepcao ) {

              this.id_recepcao = recepcao.id_recepcao;

            }

          }

        }

      }

      if ( this.edicao_local.local ) {
        this.local = this.edicao_local.local;
      }

      this.$util.setCookie('id_unidade_operacao', this.id_unidade_operacao, 365);
      this.$util.setCookie('id_recepcao', this.id_recepcao, 365);
      this.$util.setCookie('local-chamada', this.local, 365);
      this.$util.setCookie('nao-enviar-painel', this.edicao_local.nao_enviar_painel ? 1 : "", 365);
      this.$util.setCookie('recepcao-som-ao-chamar', this.edicao_local.recepcao_som_ao_chamar ? 1 : "", 365);
      this.$util.setCookie('rec-sac', this.edicao_local.nao_exibir_aviso_ao_chamar ? 1 : "", 365);
      this.$util.setCookie('te-max', this.edicao_local.te_max);
      this.$util.setCookie('rec-no-refresh', this.edicao_local.block_recep_refresh ? 'S' : '', 365);
      this.$util.setCookie('pnl-video', this.com_video ? 'S' : 'N');
      this.$util.setCookie('pnl-codigo-video', this.codigo_video);
      this.$util.setCookie('sufixo-servidor-impressao', this.sufixo_servidor_impressao);
      this.$util.setCookie('dnc', this.edicao_local.dnc ? 'S' : '', 365);

      this.refresh_exibir();

      if ( this.mostrar_local ) {
        //this.$route.path == '/recepcao' || this.$route.path == '/consultorio' ) {
        EventBus.$emit('refresh-local', this.edicao_local);
      }

      this.$util.setCookie('lab_servidor_impressao', this.lab_servidor_impressao, 365);
      this.$util.setCookie('sis', this.sis_servidor_impressao, 365);

      $('#localGlobalModal').modal('hide');
    },
    unidade_nome () {
      if ( this.$store.state.user && this.$store.state.user.id_unidade_operacao ) {
        let unidade = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.$store.state.user.id_unidade_operacao);
        return unidade ? unidade.st_nome : "";
      }
    },
    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
    logout() {

        this.$root.$children[0].reset_lista();
        this.$root.$children[0].logout();
        // this.$store.commit("setUser", null);

    },
    trocar_unidade () {
      $('#selecUnidadeModal').modal('show');
    },

    selecionar_unidade (unidade) {
      this.$store.commit('setUnidade', unidade);
      $('#selecUnidadeModal').modal('hide');
    },

    copiar_clipboard (text) {
      if (!navigator.clipboard) {
        var textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position="fixed";  //avoid scrolling to bottom
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
      } else {
        navigator.clipboard.writeText(text).then(function() {
            console.log('Async: Copying to clipboard was successful!');
        }, function(err) {
            console.error('Async: Could not copy text: ', err);
        });
      }

      this.$toast.add({
        severity: "success",
        summary: "Atenção",
        detail: "Copiado para a área de transferência.",
        life: 3000
      });
    },

    getTempoInatividade() { 
      let tempo = this.$store.state.user.tempo_inatividade;
      return tempo;
    }

  },
  mounted() {

    this.tempo_inatividade = this.getTempoInatividade();

    // Avisos

    this.$util.registrar_ref_avisos(this.$refs.avisos);

    // Solicitação de Mat/Med

    this.$util.registrar_solic_geral(this.$refs.solic_geral);

    // Unidade

    if ( this.$store.state.unidade.unidade_operacaos.length == 1 ) {
      this.id_unidade_operacao = this.$store.state.unidade.unidade_operacaos[0].id_unidade_operacao;
    } else {
      this.id_unidade_operacao = this.$util.getCookie('id_unidade_operacao');
    }

    // Recepção

    this.id_recepcao =  this.$util.getCookie('id_recepcao');

    this.lab_servidor_impressao = this.$util.getCookie('lab_servidor_impressao');
    this.sis_servidor_impressao = this.$util.getCookie('sis');

    if ( this.id_unidade_operacao ) {
      let unidade_operacao = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.id_unidade_operacao);

      if ( unidade_operacao && unidade_operacao.recepcaos.length == 1 ) {
        this.id_recepcao = unidade_operacao.recepcaos[0].id_recepcao;
      }
    }

    // Local

    this.local = this.$util.getCookie('local-chamada');

    // Tempo Máximo

    this.te_max = this.$util.getCookie('te-max');

    // Ramal

    this.ramal = this.$util.getCookie('ramal');

    // Sufixo Servidor Impressão
    this.sufixo_servidor_impressao = this.$util.getCookie('sufixo-servidor-impressao');

    this.refresh_exibir();
  },
  updated() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    });
  }
};
</script>

<style scoped>

/* Initials */

[data-initials]:before {
background: white;
color: black;
opacity: 1;
content: attr(data-initials);
display: inline-block;
font-weight: bold;
border-radius: 50%;
vertical-align: middle;
margin-right: 0.5em;
width: 30px;
height: 30px;
line-height: 30px;
text-align: center;
}

</style>

